require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-sankt-margarethen-im-burgenland.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-sankt-margarethen-im-burgenland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-sankt-margarethen-im-burgenland!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-sankt-margarethen-im-burgenland.json
// module id = 870
// module chunks = 231608221292675